export const common = {
  header: {
    companyName: 'PT. IIJ Global Solutions Indonesia',
  },
  hero: {
    headline: 'Konektivitas Pabrik Tanpa Downtime',
    subheadline: 'Pastikan operasional pabrik tetap berjalan, bahkan di lokasi terpencil',
    cta: 'Mulai dari Satu Pabrik',
  },
  problem: {
    title: 'Masalah Konektivitas yang Sering Terjadi di Pabrik',
    paragraph1: 'Banyak pabrik menghadapi tantangan berikut:\n\n1. Koneksi internet sering terputus atau tidak stabil\n2. Monitoring produksi tidak real-time\n3. Komunikasi dengan kantor pusat terhambat\n4. Ketergantungan pada satu provider lokal\n5. Risiko downtime yang berdampak langsung ke bisnis\n\nJika koneksi berhenti, operasi ikut berhenti.',
  },
  affinity: {
    title: 'Pabrik beroperasi, tetapi kantor pusat tidak dapat berkomunikasi dengan tim',
    paragraph1: 'Produksi terus berlanjut di lantai pabrik. Namun ketika konektivitas menjadi tidak stabil, komunikasi real-time terputus. Rapat video membeku. Panggilan terputus. Pesan gagal terkirim.',
    paragraph2: 'Kantor pusat tidak dapat menghubungi tim pabrik ketika keputusan perlu dibuat. Percakapan yang seharusnya memakan waktu beberapa menit tertunda berjam-jam. Manajemen beroperasi dengan informasi yang tidak lengkap dan frustrasi yang meningkat.',
  },
  solution: {
    title: 'Konektivitas satelit yang independen dari infrastruktur terestrial',
    subtitle: 'Starlink menyediakan konektivitas berbasis satelit yang beroperasi secara independen dari infrastruktur telekomunikasi lokal, memungkinkan pemantauan, kontrol, dan komunikasi berkelanjutan tanpa memandang lokasi.',
    monitoring: {
      title: 'Pemantauan Berkelanjutan',
      description: 'Visibilitas real-time ke dalam sistem produksi, status peralatan, dan metrik operasional tanpa gangguan.',
    },
    control: {
      title: 'Kontrol Jarak Jauh',
      description: 'Mempertahankan kontrol operasional dan akses sistem dari kantor pusat tanpa memandang kondisi jaringan lokal.',
    },
    communication: {
      title: 'Komunikasi yang Andal',
      description: 'Memungkinkan rapat video dan komunikasi suara antara tim pabrik dan kantor pusat tanpa ketergantungan pada infrastruktur lokal.',
    },
  },
  risk: {
    title: 'Bagaimana IIJ mengurangi risiko operasional',
    subtitle: 'IIJ merancang arsitektur jaringan yang menghilangkan titik kegagalan tunggal dengan menggabungkan Starlink dengan koneksi yang ada dan menerapkan kontrol redundansi yang tepat.',
    design: {
      title: 'Desain Jaringan',
      paragraph1: 'Insinyur IIJ merancang arsitektur jaringan khusus untuk lingkungan manufaktur, mempertimbangkan persyaratan latensi, kebutuhan bandwidth, dan skenario failover.',
      paragraph2: 'Setiap implementasi disesuaikan dengan persyaratan operasional Anda dan infrastruktur yang ada.',
    },
    integration: {
      title: 'Integrasi & Operasi',
      paragraph1: 'Konektivitas Starlink diintegrasikan dengan infrastruktur jaringan Anda yang ada, bukan menggantikannya. Ini menciptakan redundansi dan menghilangkan titik kegagalan tunggal.',
      paragraph2: 'IIJ mengelola operasi, pemantauan, dan optimisasi berkelanjutan untuk memastikan keandalan yang berkesinambungan.',
    },
    partnership: 'IIJ adalah mitra resmi Starlink, memungkinkan kami untuk secara resmi menyediakan, menerapkan, dan mendukung Starlink sebagai bagian dari arsitektur jaringan yang tahan terhadap risiko.',
  },
  offer: {
    title: 'Mulai dari satu pabrik',
    description: 'IIJ mendukung proses lengkap: desain jaringan, implementasi, dan operasi berkelanjutan. Mulai dengan satu fasilitas untuk memvalidasi pendekatan sebelum berkembang ke lokasi tambahan.',
    priority: {
      title: 'Program Prioritas',
      description: 'Program ini dirancang untuk perusahaan manufaktur yang mengoperasikan pabrik terpencil atau luar negeri di mana keandalan konektivitas secara langsung berdampak pada pengambilan keputusan operasional.',
    },
  },
  finalCta: {
    title: 'Mulai dari satu pabrik.',
    subtitle: 'Rasakan jaringan yang dirancang untuk mengurangi risiko operasional.',
    button: 'Minta Konsultasi',
  },
  footer: {
    companyName: 'PT. IIJ Global Solutions Indonesia',
    partnership: 'Mitra Resmi Starlink di Indonesia',
    address: 'Indonesia',
    email: 'info@id.iij.com',
    website: 'https://id.iij.com/en',
  },
};
